var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "login-layout blur-login",
      style: [
        _vm.isLoginApp
          ? {
              backgroundImage: "url(" + require("@/assets/images/bg.png") + ")"
            }
          : ""
      ]
    },
    [
      _c("div", { staticClass: "main-container" }, [
        _c("div", { staticClass: "main-content" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-sm-10 col-sm-offset-1" }, [
              _c("div", { staticClass: "login-container" }, [
                _c(
                  "div",
                  {
                    class: {
                      "position-relative round_black": _vm.isNTT,
                      "position-relative": !_vm.isNTT
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "forgot-box visible widget-box no-border mt-0",
                        attrs: { id: "forgot-box" }
                      },
                      [
                        _vm.sucessStatus === true
                          ? [
                              _c("div", { staticClass: "widget-body" }, [
                                _c("div", { staticClass: "widget-main" }, [
                                  _vm._m(0),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "space-6" }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "alert alert-success" },
                                    [
                                      _vm._v(
                                        "\n                      " +
                                          _vm._s(_vm.message) +
                                          "\n                    "
                                      )
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "toolbar center" },
                                  [
                                    _c(
                                      "router-link",
                                      {
                                        staticClass: "back-to-login-link",
                                        attrs: {
                                          tag: "a",
                                          to: { name: "login" }
                                        }
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "ace-icon fa fa-arrow-right"
                                        }),
                                        _vm._v(
                                          "\n                      ログインページに戻る\n                    "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ])
                            ]
                          : [
                              _c("div", { staticClass: "widget-body" }, [
                                _c("div", { staticClass: "widget-main" }, [
                                  _vm._m(1),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "space-6" }),
                                  _vm._v(" "),
                                  _vm.error === true
                                    ? _c(
                                        "div",
                                        { staticClass: "alert alert-danger" },
                                        [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(_vm.message) +
                                              "\n                    "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "form",
                                    {
                                      on: {
                                        submit: function($event) {
                                          $event.preventDefault()
                                          _vm.validateBeforeSubmit($event)
                                        }
                                      }
                                    },
                                    [
                                      _c("fieldset", [
                                        _c(
                                          "label",
                                          { staticClass: "block clearfix" },
                                          [
                                            _c(
                                              "span",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value: _vm.errors.has(
                                                      "ownerId"
                                                    ),
                                                    expression:
                                                      "errors.has('ownerId')"
                                                  }
                                                ],
                                                staticClass: "error"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.errors.first("ownerId")
                                                  )
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "block input-icon input-icon-right"
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "validate",
                                                      rawName: "v-validate",
                                                      value: "required",
                                                      expression: "'required'"
                                                    },
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.credentials.ownerId,
                                                      expression:
                                                        "credentials.ownerId"
                                                    }
                                                  ],
                                                  staticClass: "form-control",
                                                  class: {
                                                    error: _vm.errors.has(
                                                      "ownerId"
                                                    )
                                                  },
                                                  attrs: {
                                                    name: "ownerId",
                                                    type: "text",
                                                    disabled: "",
                                                    placeholder: "事業者ID",
                                                    "data-vv-as": "名前"
                                                  },
                                                  domProps: {
                                                    value:
                                                      _vm.credentials.ownerId
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.$set(
                                                        _vm.credentials,
                                                        "ownerId",
                                                        $event.target.value
                                                      )
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("i", {
                                                  staticClass:
                                                    "ace-icon fa fa-user"
                                                })
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "label",
                                          { staticClass: "block clearfix" },
                                          [
                                            _c(
                                              "span",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value: _vm.errors.has(
                                                      "userId"
                                                    ),
                                                    expression:
                                                      "errors.has('userId')"
                                                  }
                                                ],
                                                staticClass: "error"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.errors.first("userId")
                                                  )
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "block input-icon input-icon-right"
                                              },
                                              [
                                                _vm.isNTT
                                                  ? _c("input", {
                                                      directives: [
                                                        {
                                                          name: "validate",
                                                          rawName: "v-validate",
                                                          value: "required",
                                                          expression:
                                                            "'required'"
                                                        },
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.credentials
                                                              .userId,
                                                          expression:
                                                            "credentials.userId"
                                                        }
                                                      ],
                                                      staticClass:
                                                        "form-control",
                                                      class: {
                                                        error: _vm.errors.has(
                                                          "userId"
                                                        )
                                                      },
                                                      attrs: {
                                                        disabled: "",
                                                        name: "userId",
                                                        type: "text",
                                                        placeholder: "会員ID"
                                                      },
                                                      domProps: {
                                                        value:
                                                          _vm.credentials.userId
                                                      },
                                                      on: {
                                                        input: function(
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          ) {
                                                            return
                                                          }
                                                          _vm.$set(
                                                            _vm.credentials,
                                                            "userId",
                                                            $event.target.value
                                                          )
                                                        }
                                                      }
                                                    })
                                                  : _c("input", {
                                                      directives: [
                                                        {
                                                          name: "validate",
                                                          rawName: "v-validate",
                                                          value: "required",
                                                          expression:
                                                            "'required'"
                                                        },
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.credentials
                                                              .userId,
                                                          expression:
                                                            "credentials.userId"
                                                        }
                                                      ],
                                                      staticClass:
                                                        "form-control",
                                                      class: {
                                                        error: _vm.errors.has(
                                                          "userId"
                                                        )
                                                      },
                                                      attrs: {
                                                        disabled: "",
                                                        name: "userId",
                                                        type: "text",
                                                        placeholder:
                                                          "ユーザーID"
                                                      },
                                                      domProps: {
                                                        value:
                                                          _vm.credentials.userId
                                                      },
                                                      on: {
                                                        input: function(
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          ) {
                                                            return
                                                          }
                                                          _vm.$set(
                                                            _vm.credentials,
                                                            "userId",
                                                            $event.target.value
                                                          )
                                                        }
                                                      }
                                                    }),
                                                _vm._v(" "),
                                                _c("i", {
                                                  staticClass:
                                                    "ace-icon fa fa-user"
                                                })
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "label",
                                          { staticClass: "block clearfix" },
                                          [
                                            _c(
                                              "span",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value: _vm.errors.has(
                                                      "resetCode"
                                                    ),
                                                    expression:
                                                      "errors.has('resetCode')"
                                                  }
                                                ],
                                                staticClass: "error"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.errors.first(
                                                      "resetCode"
                                                    )
                                                  )
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "block input-icon input-icon-right"
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "validate",
                                                      rawName: "v-validate",
                                                      value: "required|numeric",
                                                      expression:
                                                        "'required|numeric'"
                                                    },
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.credentials
                                                          .resetCode,
                                                      expression:
                                                        "credentials.resetCode"
                                                    }
                                                  ],
                                                  staticClass: "form-control",
                                                  class: {
                                                    error: _vm.errors.has(
                                                      "resetCode"
                                                    )
                                                  },
                                                  attrs: {
                                                    name: "resetCode",
                                                    type: "text",
                                                    placeholder:
                                                      "メールにて通知されたリセットコードを入力"
                                                  },
                                                  domProps: {
                                                    value:
                                                      _vm.credentials.resetCode
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.$set(
                                                        _vm.credentials,
                                                        "resetCode",
                                                        $event.target.value
                                                      )
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("i", {
                                                  staticClass:
                                                    "ace-icon fa fa-user"
                                                })
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("span", { staticClass: "warring" }, [
                                          _vm._v(
                                            "\n                          パスワードは英大文字、英小文字、数字を組み合わせた8文字以上に設定してください。\n                        "
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "label",
                                          { staticClass: "block clearfix" },
                                          [
                                            _c(
                                              "span",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value: _vm.errors.has(
                                                      "newPassword"
                                                    ),
                                                    expression:
                                                      "errors.has('newPassword')"
                                                  }
                                                ],
                                                staticClass: "error"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.errors.first(
                                                      "newPassword"
                                                    )
                                                  )
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "block input-icon input-icon-right"
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "validate",
                                                      rawName: "v-validate",
                                                      value:
                                                        "regex:^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])",
                                                      expression:
                                                        "'regex:^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])'"
                                                    },
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.credentials
                                                          .newPassword,
                                                      expression:
                                                        "credentials.newPassword"
                                                    }
                                                  ],
                                                  staticClass: "form-control",
                                                  class: {
                                                    error: _vm.errors.has(
                                                      "newPassword"
                                                    )
                                                  },
                                                  attrs: {
                                                    name: "newPassword",
                                                    type: "password",
                                                    placeholder:
                                                      "新しいパスワード"
                                                  },
                                                  domProps: {
                                                    value:
                                                      _vm.credentials
                                                        .newPassword
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.$set(
                                                        _vm.credentials,
                                                        "newPassword",
                                                        $event.target.value
                                                      )
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("i", {
                                                  staticClass:
                                                    "ace-icon fa fa-lock"
                                                })
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "label",
                                          { staticClass: "block clearfix" },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "block input-icon input-icon-right"
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "validate",
                                                      rawName: "v-validate"
                                                    }
                                                  ],
                                                  staticClass: "form-control",
                                                  class: {
                                                    error: _vm.errors.has(
                                                      "newPassword"
                                                    )
                                                  },
                                                  attrs: {
                                                    name: "newPassword",
                                                    "data-vv-rules":
                                                      "required|confirmed:newPassword",
                                                    type: "password",
                                                    placeholder:
                                                      "再記入新しいパスワード"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("i", {
                                                  staticClass:
                                                    "ace-icon fa fa-lock"
                                                })
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "clearfix" },
                                          [
                                            _c(
                                              "router-link",
                                              {
                                                staticClass:
                                                  "width-40 pull-left btn btn-sm",
                                                attrs: {
                                                  tag: "button",
                                                  to: { name: "forgotpassword" }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                            戻る\n                          "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _vm._m(2)
                                          ],
                                          1
                                        )
                                      ])
                                    ]
                                  )
                                ])
                              ])
                            ]
                      ],
                      2
                    )
                  ]
                )
              ])
            ])
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h4", { staticClass: "header red lighter bigger" }, [
      _c("i", { staticClass: "ace-icon fa fa-key" }),
      _vm._v("\n                      パスワードリセット\n                    ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h4", { staticClass: "header red lighter bigger" }, [
      _c("i", { staticClass: "ace-icon fa fa-key" }),
      _vm._v("\n                      パスワードリセット\n                    ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "width-40 pull-right btn btn-sm btn-danger",
        attrs: { type: "submit" }
      },
      [_c("span", { staticClass: "bigger-110" }, [_vm._v("送信")])]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-50ef96cc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50ef96cc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/login/ResetPassword.vue
// module id = null
// module chunks = 